module.exports = __webpack_public_path__ + "static/img/4485_phase_function_Paper_Points.d89c1ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4485_phase_function_Paper_Points.png
// module id = JV2F
// module chunks = 0